import { ChangeDetectorRef, Component, Input, ViewContainerRef, ViewEncapsulation } from "@angular/core";
import { Person } from "@common/ADAPT.Common.Model/person/person";
import { BaseComponent } from "@common/ux/base.component/base.component";

@Component({
    selector: "adapt-mention-person",
    templateUrl: "./mention-person.component.html",
    styleUrls: ["./mention-person.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class MentionPersonComponent extends BaseComponent {
    @Input() public person!: Person;

    public static generateHtmlForPerson(viewContainerRef: ViewContainerRef, person: Person) {
        const componentRef = viewContainerRef.createComponent(MentionPersonComponent);
        componentRef.setInput("person", person);
        const element = componentRef.location.nativeElement;
        // just creating this element to extract the html to be loaded by tributejs, which can't load angular component.
        // don't show the component.
        element.style.display = "none";

        const changeDetectorRef = componentRef.injector.get(ChangeDetectorRef);
        changeDetectorRef.detectChanges();
        const htmlString = element.innerHTML; // taking innerHTML so won't be affected by the display none
        componentRef.destroy(); // destroy the component after extracting the html
        return htmlString;
    }
}
